
(() => {
  const ready = new WeakSet();
  const setup = root => {
    if (ready.has(root)) return;
    ready.add(root);
    const filters = Array.from(root.querySelectorAll('[data-bf-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-bf-card]'));
    const count = root.querySelector('[data-bf-count]');
    const empty = root.querySelector('[data-bf-empty]');
    const update = () => {
      let shown = 0;
      cards.forEach(card => {
        const visible = filters.every(filter => filter.value === 'all' || card.dataset[filter.dataset.bfFilter] === filter.value);
        card.hidden = !visible;
        if (visible) shown += 1;
      });
      count.textContent = `${shown} / ${cards.length}`;
      empty.hidden = shown !== 0;
    };
    filters.forEach(filter => filter.addEventListener('change', update));
    root.querySelector('[data-bf-filters]').hidden = false;
    update();
  };
  const scan = scope => {
    if (scope.matches && scope.matches('[data-bf-shop]')) setup(scope);
    scope.querySelectorAll('[data-bf-shop]').forEach(setup);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), {once:true});
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
